import type { Translations } from './types';

const it: Translations = {
    next: 'Avanti',
    storyReadPrompt: 'Per favore, leggi prima la storia.',
    backToStory: '← Torna alla storia',
    nextArrow: 'Avanti →',
    finishAssessment: 'Termina la valutazione →',
    common_step: 'Passo',
    questionsStory1: 'Domande — Storia 1',
    questionsStory2: 'Domande — Storia 2',
    lastSetOfQuestions: 'Ultime domande — quasi finito! 🎉',
    typeAnswerHere: 'Scrivi qui la tua risposta...',
    backCountSingular: '📖 Sei tornato {n} volta su questa pagina per rileggere la storia.',
    backCountPlural: '📖 Sei tornato {n} volte su questa pagina per rileggere la storia.',

    assessmentComplete: 'Valutazione Completata! 🎉',
    assessmentSubtitle: 'Hai fatto un passo importante verso la comprensione delle differenze di apprendimento',
    returnToHome: 'Torna alla Home',
    assessmentSuccessfullyCompleted: 'Valutazione Completata con Successo',
    amazingJob: 'Ottimo Lavoro!',
    youCrushedIt: "Ce l'hai fatta! Ecco cosa hai ottenuto:",
    whatsNext: 'Cosa succede ora?',
    getReadyForResults: 'Preparati per i tuoi risultati personalizzati',
    youDidIt: "Ce l'hai fatta!",
    youDidItDesc:
      "Il tuo impegno nel comprendere le differenze di apprendimento è davvero d'ispirazione. Mentre altri avrebbero rinunciato, tu sei andato fino in fondo!",

    heroLine1: 'DISLESSIA',
    heroLine2: 'SCREENING',
    heroTagline: 'in una sola sessione',
    heroSubtitle:
      'Una valutazione multimodale nel browser che ti dà un rapporto scritto appena finisci — senza visite in clinica, senza liste d\'attesa, senza hardware speciale.',
    heroBetaLabel: 'BETA',
    startAssessment: 'Inizia',
    trustedBy: 'Scelto da educatori e ricercatori in tutto il mondo',

    pfp_privacyBadge: 'Privacy e Conformità',
    pfp_privacyHeading: 'Prendiamo sul serio la protezione dei dati con piena conformità GDPR e MDR',
    pfp_formBadge: 'Inizia la Tua Valutazione',
    pfp_ctaHeading: 'SCREENING PER LA DISLESSIA',
    pfp_ctaDesc: 'Unisciti a migliaia di persone che hanno scoperto informazioni uniche sul loro stile di lettura attraverso la nostra valutazione basata su intelligenza artificiale.',
    pfp_ctaFooter: 'Nessun limite di tempo • Al tuo ritmo • 100% riservato',
    pfp_whyTitle: 'Perché DysTest?',
    pfp_whySubtitle: 'Scopri cosa rende la nostra valutazione basata su AI la soluzione più accurata e affidabile',
    pfp_whyDesc: 'DysTest combina oltre 20 anni di competenza professionale nella ricerca sulla dislessia con una vita di esperienza diretta. Ricostruendo come i lettori dislessici e neurotipici elaborano il testo, la nostra AI impara a distinguere sottili schemi di lettura che i test tradizionali non colgono.',
    pfp_feature1Title: 'Tracciamento oculare, tastiera e analisi multilingue',
    pfp_feature1Desc: "L'AI avanzata analizza i movimenti oculari, le espressioni facciali e i tasti premuti per rivelare schemi di apprendimento unici per ogni lettore — in qualsiasi lingua. DysTest si adatta in modo intelligente agli utenti multilingue per una comprensione precisa e personalizzata.",
    pfp_feature2Title: 'Risultati Immediati e Utili',
    pfp_feature2Desc: "Ottieni informazioni chiare e scientificamente fondate in pochi minuti. I nostri rapporti traducono dati complessi in raccomandazioni facili da capire che aiutano genitori, educatori e studenti.",
    pfp_feature3Title: 'Privacy e Conformità Prima di Tutto',
    pfp_feature3Desc: "I tuoi dati sono crittografati, anonimizzati e gestiti secondo i più elevati standard etici e normativi — pienamente conformi a GDPR e MDR. Niente viene condiviso o utilizzato al di là del miglioramento della tua esperienza DysTest.",
    pfp_feature4Title: 'Design Accessibile e Incentrato sull\'Uomo',
    pfp_feature4Desc: "DysTest ti permette di fare lo screening al tuo ritmo — calmo, intuitivo e senza pressioni. Progettato per l'inclusività, l'accessibilità e la comprensione significativa, ridefinisce come le differenze di apprendimento vengono scoperte e supportate.",
    pfp_finalCtaDesc: 'Inizia oggi il tuo screening personalizzato per la dislessia basato su AI — progettato per capire come leggi, non solo cosa leggi.',

    hiw_badge: 'Processo Semplice in 8 Passi',
    hiw_heading: 'Come Funziona la Valutazione',
    hiw_subtext: "Dalla registrazione a un rapporto dettagliato sulla dislessia — interamente nel browser, senza download.",
    hiw_step1Title: 'Registrati',
    hiw_step1Desc: 'Inserisci il tuo nome, età e lingua preferita. Nessun account richiesto — meno di 2 minuti.',
    hiw_step2Title: 'Calibra gli Occhi',
    hiw_step2Desc: "Segui 16 punti animati sullo schermo. Il tracker dell'iride AI impara la tua firma visiva unica.",
    hiw_step3Title: 'Parole & Immagini',
    hiw_step3Desc: 'Abbina le parole alle loro immagini mentre misuriamo la velocità di riconoscimento e il trattamento visivo-fonologico.',
    hiw_step4Title: 'Test di velocità RAN',
    hiw_step4Desc: 'Nomina ad alta voce una sequenza di colori o oggetti il più velocemente possibile. Misura la fluidità di recupero.',
    hiw_step5Title: 'Storie & Domande',
    hiw_step5Desc: "Leggi due storie adatte alla tua età e rispondi a domande di comprensione. I movimenti oculari e i battiti di ciglia vengono registrati.",
    hiw_step6Title: 'Scrittura di parole',
    hiw_step6Desc: "Digita parole a memoria. I tempi di battitura e i pattern di errore rivelano l'elaborazione ortografica e motoria.",
    hiw_step7Title: 'Feedback',
    hiw_step7Desc: 'Condividi la tua esperienza e le tue preoccupazioni. Questo contesto aiuta a calibrare l\'interpretazione clinica.',
    hiw_step8Title: 'Ottieni i Risultati',
    hiw_step8Desc: 'Ricevi un rapporto dettagliato con indicatori di rischio di dislessia, heatmap dello sguardo e metriche di lettura.',

    pf_whoTaking: 'Chi fa il test?',
    pf_myself: 'Io stesso',
    pf_myselfAge: 'Età 13+',
    pf_child: 'Mio figlio',
    pf_childAgeRange: 'Età 5-12',
    pf_verifyEmailTitle: 'Verifica la tua Email',
    pf_parentalConsentStepTitle: 'Consenso Genitoriale',
    pf_verifyEmailDesc: 'Inserisci il codice inviato alla tua email per completare la registrazione',
    pf_consentDesc: 'Si prega di leggere e fornire il consenso al trattamento dei dati',
    pf_yourName: 'Nome del partecipante *',
    pf_yourNamePlaceholder: 'Inserisci il tuo nome completo',
    pf_emailAddress: 'Indirizzo Email *',
    pf_assessmentLanguage: 'Lingua della valutazione',
    pf_emailPlaceholder: 'Inserisci la tua email',
    pf_invalidEmail: 'Inserisci un indirizzo email valido',
    pf_yourAge: 'La tua Età *',
    pf_selectAge: 'Seleziona fascia d\'età',
    pf_yearsUnit: 'anni',
    pf_dyslexiaTested: 'Sei mai stato testato per la dislessia?',
    pf_iAmDyslexic: 'Sì, diagnosticato ufficialmente',
    pf_iAmNotDyslexic: 'Testato e non dislessico',
    pf_notKnown: 'Non testato',
    pf_parentName: 'Nome del Genitore *',
    pf_parentNamePlaceholder: 'Inserisci il nome del genitore',
    pf_childName: 'Nome del Bambino *',
    pf_childNamePlaceholder: 'Inserisci il nome del bambino',
    pf_childAgeLabel: "Età del Bambino *",
    pf_selectChildAge: "Seleziona fascia d'età",
    pf_childDyslexiaTested: 'Tuo figlio è mai stato testato per la dislessia?',
    pf_yesHasDyslexia: 'Sì, diagnosticato ufficialmente',
    pf_yesNoDyslexia: 'Testato e non dislessico',
    pf_noNotTested: 'No, mai testato',
    pf_nativeLangQuestion: 'Che lingua parli a casa?',
    pf_browserLangDetected: 'Lingua del browser rilevata:',
    pf_availableInSystem: '✓ Disponibile nel nostro sistema',
    pf_yesNative: 'Sì',
    pf_othersNative: 'Altro',
    pf_specifyNative: 'Specifica la tua lingua madre *',
    pf_selectNativePlaceholder: 'Seleziona la tua lingua madre',
    pf_selectNativeError: 'Seleziona la tua lingua madre',
    pf_nativeLangNote: 'Questo ci aiuta a fornire risultati di valutazione più accurati in base al tuo background linguistico. La lingua del tuo browser ({lang}) è stata rilevata automaticamente — non utilizziamo mai il tuo indirizzo IP per il rilevamento della lingua.',
    pf_forYourChild: 'Per Tuo Figlio',
    pf_childExplanation: 'Il computer guarda come leggi — il tuo viso, gli occhi e come scrivi — per capire il tuo stile di lettura. Non succede nulla di brutto ai tuoi dati. Il tuo genitore ha detto che va bene, e puoi fermarti quando vuoi.',
    pf_parentalConsentLabel: 'Consenso Genitoriale *',
    pf_parentalConsentText: "Acconsento al trattamento dei dati facciali, di movimento oculare e di interazione con la tastiera di mio figlio (o miei) per lo screening della dislessia e la valutazione dell'apprendimento in conformità con il GDPR e il MDR.",
    pf_dataConsentLabel: 'Consenso al Trattamento dei Dati e Privacy *',
    pf_dataConsentText: 'Accetto il trattamento dei miei dati personali per scopi di screening.\nHo letto e accetto la Privacy Policy e i Termini di Servizio.',
    pf_consentPre: 'Accetto la',
    pf_consentPrivacyLink: 'Privacy Policy',
    pf_consentBetween: 'e i',
    pf_consentTermsLink: 'Termini di Servizio',
    pf_consentPost: ', incluso il trattamento dei dati per scopi di screening.',
    pf_emailFailedTitle: 'Invio Email Fallito',
    pf_checkYourEmail: 'Controlla la tua Email',
    pf_emailSentDesc: 'Abbiamo inviato un codice di verifica a 6 cifre a {email}. Controlla la tua casella di posta e inserisci il codice qui sotto.',
    pf_emailFailedDesc: 'Invio a {email} fallito.',
    pf_tryAgain: 'Riprova',
    pf_sendingEmail: 'Invio in corso...',
    pf_verificationCodeLabel: 'Codice di Verifica *',
    pf_enterCodePlaceholder: 'INSERISCI CODICE A 6 CIFRE',
    pf_codeExpiry: "Inserisci il codice a 6 cifre dalla tua email. Il codice scade in 15 minuti.",
    pf_resendCode: 'Non hai ricevuto il codice? Clicca per rinviare',
    pf_sendingNewCode: 'Invio nuovo codice...',
    pf_continue: 'Continua',
    pf_continueToConsent: 'Continua al Consenso',
    pf_verifyEmailBtn: 'Verifica Email',
    pf_verifying: 'Verifica in corso...',
    pf_processing: 'Elaborazione...',
    pf_importantNotice: 'Avviso Importante',
    pf_disclaimer: 'DysTest è uno strumento digitale di screening progettato per supportare il rilevamento precoce e le informazioni sull\'apprendimento. Non fornisce una diagnosi medica. Per una diagnosi ufficiale o un consiglio clinico, si prega di consultare professionisti sanitari qualificati.',

            cg_readingAssessment: 'Valutazione della lettura',
    cg_whatsNext: 'Ecco cosa viene dopo',
    cg_twoSections: 'Due brevi sezioni — leggi una storia e poi rispondi ad alcune domande',
    cg_readStory: 'Leggi la storia',
    cg_readStoryDesc: 'Prenditi il tuo tempo — leggi al tuo ritmo',
    cg_answerQuestions: 'Rispondi ad alcune domande',
    cg_answerQuestionsDesc: 'Scrivi le tue risposte con le tue parole — non ci sono risposte giuste o sbagliate',
    cg_exampleQuestion: "Cosa è successo all'inizio della storia?",
    cg_exampleAnswer: 'Il ragazzo è andato al parco…',
    cg_startReading: 'Inizia a leggere',
    cg_warmupGame: 'Gioco di riscaldamento',
    cg_matchHeading: "Abbina la parola all'immagine",
    cg_matchSubtitle: "Clicca su una scheda parola e poi sull'immagine corrispondente per completare la coppia",
    cg_startMatching: 'Inizia!',
    cg_demoWord: 'gatto',
    cg_allMatched: 'Tutte le coppie abbinate!',
    cg_heatmapContinuing: 'La tua heatmap dello sguardo è mostrata qui sotto — continuazione a breve…',
    cg_lookAtTarget: '👁️ Guardando il bersaglio!',
    cg_lookAtDot: 'Guarda il punto rosso',
    cg_sRemaining: 's rimanenti',
    cg_skipFixation: 'Salta Fissazione',
    cg_correct: '✓ Corretto!',
    cg_tryAgain: '✗ Riprova',
    cg_liveMetrics: 'Metriche in Diretta',
    cg_blinks: 'Battiti di ciglia',
    cg_matched: 'Abbinati',
    cg_errors: 'Errori',

    fpc_instruction: 'Guarda ogni punto',
    fpc_dotsTotal: 'punti in totale — guarda direttamente ogni punto e mantieni lo sguardo. Si acquisisce automaticamente.',
    fpc_cancelCalibration: 'Annulla calibrazione',
    fpc_clickMe: 'Clicca qui!',
    fpc_eyeTrackingStarting: 'Tracciamento oculare in avvio — puoi già cliccare!',
    fpc_calibrationComplete: 'Calibrazione Completata!',
    fpc_trainingSamples: '{n} campioni di addestramento registrati',
    fpc_allPointsDone: 'Tutti i punti completati!',
    fpc_pointOf: 'Punto {current} di {total}',
    fpc_training: 'Addestramento',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'Salvataggio calibrazione…',
    fpc_moveEyes: 'Muovi gli occhi verso il punto…',
    fpc_noFace: '⚠️ Nessun volto rilevato — centra il tuo viso nella fotocamera',
    fpc_missingIrisTitle: "⚠️ Dati dell'iride mancanti su troppi punti",
    fpc_missingIrisBody: "Diversi punti di calibrazione sono stati saltati perché i punti di riferimento dell'iride non sono stati rilevati.",
    fpc_lowAccuracyTitle: 'Precisione inferiore alle aspettative',
    fpc_lowAccuracyBody: "L'errore di calibrazione è superiore all'ideale. Ciò può ridurre la precisione del tracciamento oculare.",
    fpc_redoCalibration: 'Ripeti calibrazione',
    fpc_continueAnyway: 'Continua comunque',
    fpc_lookAtDot: 'Guarda direttamente il punto',
    fpc_dotReady: '✓ Punto acquisito — avanzamento…',
    fpc_keepLooking: 'Continua a guardare il punto — si acquisisce automaticamente',
    fpc_captured: '✓ Acquisito! Passando al prossimo…',
    fpc_checkingAccuracy: 'Verifica precisione',
    fpc_valGotIt: 'Acquisito! Passando al prossimo…',
    fpc_valHoldStill: 'Fermo — raccolta dati in corso…',
    fpc_valLookDot: 'Guarda il punto — diventa arancione quando è pronto',
    fpc_valCheck: 'VERIF',

    acp_welcome: 'Benvenuto, {name}!',
    acp_setupSubtitle: 'Configuriamo la tua valutazione',
    acp_setupVerification: 'Verifica Configurazione',
    acp_setupStepsDesc: 'Completa tutti i passaggi per sbloccare la valutazione',
    acp_step1Title: 'Camera Attiva',
    acp_step1Desc: 'La camera si avvia automaticamente — nessuna azione necessaria',
    acp_step2Title: 'Verifica Camera',
    acp_step2Desc: 'Verifica la qualità e la stabilità della camera',
    acp_step3Title: 'Test di Digitazione',
    acp_step3Desc: 'Verifica il funzionamento della tastiera',
    acp_step4Title: 'Calibrazione Oculare',
    acp_step4Desc: 'Calibra il sistema di tracciamento oculare',
    acp_eyeTrackingActive: '✓ Tracciamento oculare attivo',
    acp_eyeTrackingError: '⚠ Errore tracciamento oculare:',
    acp_startingEyeTracking: '⏳ Avvio tracciamento oculare...',
    acp_cameraReady: '👁 Camera pronta',
    acp_waitingForCamera: '📷 Camera in avvio automatico...',
    acp_stepDone: 'Completato',
    acp_stepInProgress: 'In Corso',
    acp_checkingCameraStability: 'Verifica stabilità camera...',
    acp_cameraVerified: 'Camera Verificata ✓',
    acp_autoVerifyingCamera: 'Verifica automatica camera...',
    acp_waitingFaceDetection: 'In attesa del rilevamento del viso...',
    acp_eyeTrackingStarting: 'Avvio tracciamento oculare...',
    acp_calibrationInProgress: 'Calibrazione in corso...',
    acp_eyeTrackingReady: 'Tracciamento Oculare Pronto ✓',
    acp_startingCalibration: 'Avvio calibrazione...',
    acp_distanceHint: 'Tieni il viso al centro e fermo, a non più di 60 cm dallo schermo',
    acp_distanceLabel: 'max 60 cm',
    acp_fpsTitle: 'La tua fotocamera è un po\' lenta',
    acp_fpsBody: 'Fornisce {fps} immagini al secondo; ne servono almeno 10 per misurare lo sguardo. Di solito questo aiuta in pochi secondi:',
    acp_fpsVeryLow: 'A questa velocità alcune misure dei movimenti oculari potrebbero non essere utilizzabili; gli altri compiti contano comunque.',
    acp_fpsTipLight: 'Accendi più luce o mettiti con il viso verso una finestra',
    acp_fpsTipCharger: 'Collega il caricabatterie (il risparmio energetico rallenta il portatile)',
    acp_fpsTipApps: 'Chiudi le videochiamate e gli altri programmi pesanti',
    acp_fpsCheckAgain: 'Controlla di nuovo',
    acp_fpsChecking: 'Controllo in corso…',
    acp_fpsContinue: 'Continua comunque',
    acp_preparingEyeTracking: 'Preparazione tracciamento oculare...',
    acp_cameraPreview: 'Anteprima Camera',
    acp_noFaceDetected: 'Nessun viso rilevato',
    acp_live: 'LIVE',
    acp_cameraVerifiedTitle: 'Camera Verificata ✓',
    acp_cameraReadyTitle: 'Camera Pronta',
    acp_qualityCheckPassed: 'Controllo qualità superato',
    acp_optimizedForAssessment: 'Ottimizzata per la valutazione',
    acp_verifiedBadge: 'Verificata',
    acp_readyBadge: 'Pronta',
    acp_assessmentMetrics: 'Metriche di Valutazione',
    acp_faceDistance: 'Distanza Viso',
    acp_goodDistance: 'Buona distanza per la valutazione',
    acp_searching: 'Ricerca in corso...',
    acp_lightLevel: 'Livello di Luce',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'Frequenza fotogrammi eccellente',
    acp_fpsGood: 'Buona frequenza fotogrammi',
    acp_fpsModerate: 'Frequenza fotogrammi moderata',
    acp_fpsLow: 'Frequenza fotogrammi bassa',
    acp_fpsInitializing: 'Inizializzazione...',
    acp_faceDetection: 'Rilevamento Viso',
    acp_faceDetected: '✓ Rilevato',
    acp_faceDetectedSub: 'Viso rilevato con successo',
    acp_cameraQualityPassed: 'Controllo qualità camera superato. Pronto per il passo successivo.',
    acp_visionWarnings: 'Avvisi Visivi',
    acp_trackingMetrics: 'Metriche di Tracciamento',
    acp_headPitch: 'Inclinazione Testa:',
    acp_headYaw: 'Rotazione Testa:',
    acp_headRoll: 'Rollio Testa:',
    acp_gazePoint: 'Punto di Sguardo:',
    acp_emotion: 'Emozione:',
    acp_confidence: 'Fiducia:',
    acp_trackingId: 'ID Tracciamento:',
    acp_faceId: 'ID Viso:',
    acp_browser: 'Browser:',
    acp_os: 'SO:',
    acp_camera: 'Camera:',
    acp_resolution: 'Risoluzione:',
    acp_initializingTracking: 'Inizializzazione metriche di tracciamento...',
    acp_dataQuality: 'Qualità Dati',
    acp_dataQualityExcellent: 'ECCELLENTE',
    acp_dataQualityGood: 'BUONA',
    acp_dataQualityFair: 'DISCRETA',
    acp_dataQualityDetecting: 'RILEVAMENTO...',
    acp_dataQualityExcellentDesc: 'Ottimale per la valutazione',
    acp_dataQualityGoodDesc: 'Buona per la valutazione',
    acp_dataQualityFairDesc: 'Qualità accettabile',
    acp_dataQualityDetectingDesc: 'Analisi condizioni',
    acp_faceMeshPoints: 'Punti Mesh Facciale',
    acp_completeFaceMesh: 'Mesh facciale completa',
    acp_detecting: 'Rilevamento...',
    acp_typingTest: 'Test di Digitazione',
    acp_typeQwerty: 'Digita {target} per verificare la tastiera',
    acp_verifyKeyboard: 'Verifica il funzionamento della tastiera',
    acp_activeStatus: 'Attivo',
    acp_lockedStatus: 'Bloccato',
    acp_typeHere: 'Digita qui...',
    acp_typingCompleted: '✓ Completato! Passaggio al passo successivo...',
    acp_keepTyping: 'Continua a digitare:',
    acp_remaining: 'rimanenti',
    acp_startTyping: 'Inizia a digitare le lettere sopra',
    acp_completeCameraVerification: 'Completa la verifica della camera per sbloccare',
    acp_lightingPerfect: 'Illuminazione perfetta per la valutazione',
    acp_lightingSlightlyBright: 'Leggermente luminoso - riduci se possibile',
    acp_lightingTooBright: 'Troppo luminoso - riduci illuminazione/luminosità schermo',
    acp_lightingSlightlyDim: 'Leggermente fioco - aumenta se possibile',
    acp_lightingTooDim: 'Troppo fioco - aumenta illuminazione',
    acp_positionFace: '👤 Posiziona il viso nel campo visivo della camera',
    acp_faceDetectedStarting: '✅ Viso rilevato - avvio verifica...',
    acp_adjustDistance: 'Regola la distanza dalla videocamera',
    acp_moveFarther: 'Allontanati dalla videocamera',
    acp_distanceInRange: 'La distanza va bene',
    pdg_moveCloser: 'Avvicinati alla videocamera',
    pdg_moveFarther: 'Allontanati dalla videocamera',
    pdg_dismiss: 'Ignora',
    acp_noData: 'Nessun dato',
    acp_setupProgress: 'Avanzamento Configurazione',
    acp_stepsComplete: '{n} di 4 passi completati',
    acp_environment: 'Ambiente',
    acp_checkingEllipsis: 'Verifica…',
    acp_waitingEllipsis: 'Attesa…',
    acp_analysingConditions: 'Analisi condizioni camera…',
    acp_positionFaceCamera: 'Posiziona il viso nella camera',
    acp_faceAligned: 'Viso allineato',
    shared_stepOf: 'Passo {step} di {total}',
    shared_start: 'inizia',
    cal_introHeading: 'CALIBRAZIONE',
    cal_introSubtitle: 'Segui i punti e tieni la testa ferma',
    story_introHeading: 'LETTURA E DOMANDE',
    fpc_lookHere: '👆 Clicca il punto per continuare',
            pfp_chip_gdpr: 'Conforme GDPR',
    pfp_chip_mdr: 'Allineato MDR',
    pfp_chip_noData: 'Nessuna condivisione dati',
    pfp_chip_languages: '8 Lingue',
    kbv_header: 'Dinamica tastiera',
    kbv_interKey: 'Intervallo tra tasti',
    kbv_typingSpeed: 'Velocità di scrittura',
        pfp_aiBadge: 'Strumento di screening dislessia con tracciamento oculare',
    pfp_whyBadge: 'Perché DysTest',
    mat_missionBadge: 'La nostra missione e tecnologia',
    mat_eyeBadge: 'Tracciamento oculare',
    mat_kbdBadge: 'Analisi delle sequenze di tasti',
    mat_ferBadge: 'Espressione facciale',
    pfp_noBrowserFooter: 'Nessun account necessario · Interamente nel browser · Risultati in <15 minuti',
    eye_viz_landmarks: '478 Punti chiave',
    eye_viz_irisFaceMesh: 'Iride + Mesh facciale',
    eye_viz_fps: '30 FPS in tempo reale',
    eye_viz_validation: 'Validazione 9 + 4 punti',
    eye_viz_calibration: 'Calibrazione clinica a 13 punti',
    ran_anim_rapidNaming: 'Denominazione rapida',
    ran_anim_predictor: '#1 indicatore di dislessia',
    ran_anim_ageNormed: 'Punteggio per età',
    ran_anim_zscore: 'punteggio z + percentile',
    acp_hideDetails: 'Nascondi dettagli ▲',
    acp_showDetails: 'Mostra dettagli ▼',
    acp_moveCloser: 'avvicinati',
    acp_headLabel: 'Testa',
    acp_setupTipsTitle: 'Consigli Rapidi per la Configurazione',
    acp_tip1: 'Siediti a circa 50 cm (lunghezza del braccio) dallo schermo',
    acp_tip2: 'Assicurati di avere un\'illuminazione uniforme e luminosa sul viso',
    acp_tip3: 'Mantieni la testa dritta e guarda direttamente la camera',
    acp_tip4: 'Usa uno spazio tranquillo per una valutazione senza distrazioni',
    acp_progressLabel: 'Avanzamento',

    priv_gdprTitle: 'Conforme al GDPR',
    priv_gdpr1: 'Consenso genitoriale verificabile per gli utenti sotto i 13 anni',
    priv_gdpr2: 'Minimizzazione dei dati e limitazione delle finalità',
    priv_gdpr3: 'Diritto di accesso, rettifica ed eliminazione dei dati',
    priv_gdpr4: 'Trattamento trasparente dei dati',
    priv_mdrTitle: 'Allineato al MDR',
    priv_mdr1: 'Protezione aggiuntiva per soggetti vulnerabili',
    priv_mdr2: 'Sicurezza e prestazioni cliniche',
    priv_mdr3: 'Chiara distinzione tra screening e diagnosi',
    priv_mdr4: 'Gestione etica dei dati sanitari',
    priv_retentionTitle: 'Politica di Conservazione dei Dati',
    priv_12months: '12 Mesi',
    priv_12monthsDesc: 'Coordinate di eye-tracking e tasti premuti',
    priv_24months: '24 Mesi',
    priv_24monthsDesc: 'Metadati di analisi',
    priv_parentsControl: 'Controllo Genitori',
    priv_deleteAnytime: 'Elimina in qualsiasi momento',

    mat_headline1: 'EMPATIA UMANA.',
    mat_headline2: 'PRECISIONE ARTIFICIALE',
    mat_subheadline: "Combiniamo l'esperienza vissuta con l'AI all'avanguardia per rendere lo screening della dislessia",
    mat_subheadlineHighlight: 'accessibile a tutti',
    mat_whatTitle: 'COSA FACCIAMO',
    mat_what1: "Combiniamo una profonda competenza negli schemi di lettura dislessa con la tecnologia AI avanzata. Dopo anni di ricerca su come la dislessia influenza la lettura e dove il cervello deve lavorare di più, abbiamo trasmesso queste intuizioni a un'AI adattiva.",
    mat_what2: "La nostra AI conduce test intelligenti e multistrato — ogni risposta viene confrontata con migliaia di schemi di lettura reali. Impara in tempo reale, ponendo le domande di approfondimento giuste e cogliendo segnali sottili che i test tradizionali trascurano.",
    mat_what3: 'Tutto per dare alle famiglie la chiarezza di cui hanno bisogno per fare il passo successivo con fiducia.',
    mat_whyTitle: 'PERCHÉ LO FACCIAMO',
    mat_why1: 'Immagina tuo figlio che affronta le stesse difficoltà di lettura che hai vissuto tu — ma ora sai che ha un nome: dislessia. Vuoi risposte, ma il primo passo è un test che costa da 750 € a 1.800 € — irraggiungibile per molte famiglie.',
    mat_why2: "Questa realtà ci spezza il cuore. Ogni bambino merita di capire come impara. Ogni genitore merita risposte.",
    mat_why3: "Ecco perché siamo qui — perché capire la propria mente non dovrebbe mai essere un privilegio. È un diritto umano.",
    mat_bgTitle: 'IL NOSTRO BACKGROUND',
    mat_bg1: "Abbiamo vissuto la dislessia in prima persona e abbiamo trascorso oltre 20 anni a specializzarci nella lettura accessibile. Combinando questa esperienza vissuta con l'AI, abbiamo creato uno strumento di screening della dislessia semplice, accessibile e in grado di cambiare la vita.",
    mat_bg2: "La nostra AI non si limita a misurare la velocità di lettura o a contare gli errori — comprende il come dietro ogni movimento oculare, pausa e recupero. Esamina i processi cognitivi che rendono la lettura particolarmente impegnativa.",
    mat_techTitle: 'LA NOSTRA TECNOLOGIA',
    mat_tech1: "Amplificando queste sottili differenze, il nostro sistema impara a distinguere la dislessia da altre sfide di lettura con straordinaria precisione. Utilizziamo il clustering profondo — una forma avanzata di apprendimento non supervisionato — per riconoscere le caratteristiche sfumate del cervello dislessa.",
    mat_tech2: 'Questo approccio multistrato e cross-referenziato porta a una maggiore certezza rispetto a qualsiasi metodo precedente — andando più in profondità e più lontano che mai.',
    mat_eyeTitle: 'Tracciamento Oculare',
    mat_eyeText: "Misuriamo la stabilità dello sguardo, la durata della fissazione e il movimento saccadico per rivelare come si sposta l'attenzione visiva durante la lettura.",
    mat_kbdTitle: 'Dinamica della Tastiera',
    mat_kbdText: "Il ritmo dei tasti, le esitazioni e la velocità di correzione rivelano sfide di sequenziamento e fonologiche uniche dei profili dislessici.",
    mat_ferTitle: 'Riconoscimento delle Emozioni Facciali (FER)',
    mat_ferText: "Le espressioni sottili rivelano frustrazione, coinvolgimento o sollievo — aiutando la nostra AI a percepire lo strato emotivo dietro lo sforzo di lettura.",

    footer_about: 'Chi siamo',
    footer_blog: 'Pubblicazioni',
    footer_contact: 'Contatti',
    footer_faq: 'FAQ',
    footer_privacy: 'Privacy',
    footer_terms: 'Termini di Servizio',
    footer_tagline: "Screening della dislessia basato su AI tramite tracciamento dell'iride in tempo reale, dinamica della tastiera e analisi delle espressioni facciali — disponibile in 8 lingue, completamente nel browser.",
    footer_productHeading: 'Prodotto',
    footer_legalHeading: 'Legale',
    footer_mission: 'Creato per rendere lo screening della dislessia accessibile a tutti, in ogni lingua.',
    footer_copyright: 'Tutti i diritti riservati',
    footer_madeWith: 'Creato con uno scopo per la consapevolezza della dislessia',
    footer_allSystems: 'Tutti i sistemi operativi',

    fp_assessmentBadge: 'Ultimo passaggio',
    fp_feedbackTitle: 'Condividi una nota finale',
    fp_feedbackDesc: 'Un feedback facoltativo ci aiuta a migliorare l’esperienza di valutazione.',
    fp_shareThoughts: 'Condividi i tuoi pensieri',
    fp_optional: 'Facoltativo',
    fp_words: 'Parole',
    fp_corrections: 'Correzioni',
    fp_speed: 'Velocità',
    fp_feedbackPlaceholder: 'Qualcosa è stato difficile, poco chiaro o migliorabile?',
    fp_observationNotesTitle: 'Note di osservazione (facoltativo)',
    fp_observationNotesDesc: 'Per il genitore o il supervisore presente durante il test: qualsiasi cosa tu abbia notato che lo schermo non può vedere — distrazione, stanchezza, pianto, rumore o qualsiasi altra cosa utile da registrare insieme ai risultati.',
    fp_observationNotesPlaceholder: 'es. "Sembrava stanco durante il test di scrittura delle parole" oppure "Distratto da un fratello durante la Storia 1"',
    fp_generatingReport: 'Generazione del tuo rapporto…',
    fp_submitBtn: 'Termina e vedi il report',
    fp_skipHint: 'Il feedback è facoltativo. Continua quando sei pronto.',
    fp_youNailedIt: 'Valutazione completata',
    fp_reportGenerated: 'Il tuo report è pronto nella dashboard.',
    fp_copySentTo: 'Dettagli di accesso inviati a',
    fp_welcomeBack: 'Report salvato',
    fp_newReportAdded: 'Aggiunto ai risultati della tua dashboard.',
    fp_reportReady: 'Il tuo rapporto è pronto',
    fp_reportSubtitle: 'Analisi completa, riproduzione del tracciamento oculare e indicatori di dislessia',
    fp_openingReport: 'Apertura del tuo rapporto…',
    fp_viewMyReport: 'Visualizza il Mio Rapporto',
    fp_signInLater: 'o accedi più tardi su',
    fp_saveForAccess: 'Salva per accesso futuro',
    fp_emailLabel: 'Email',
    fp_passwordLabel: 'Password',
    fp_copied: 'Copiato',
    fp_copy: 'Copia',
    fp_pwUpdated: 'Password aggiornata con successo',
    fp_setCustomPw: 'Imposta una password personalizzata',
    fp_newPwPlaceholder: 'Nuova password (min 4 caratteri)',
    fp_save: 'Salva',
    fp_cancel: 'Annulla',
    fp_signInLink: 'Apri dashboard →',
    fp2_saving: 'Salvataggio dei risultati…',
    fp2_savingSub: 'Ci vogliono pochi secondi. Tieni aperta questa pagina.',
    fp2_allDone: 'Fatto',
    fp2_reportReadySent: 'Il rapporto è pronto. Abbiamo inviato i dati di accesso a',
    fp2_reportReadyReturning: 'Il rapporto è pronto ed è stato aggiunto alla tua dashboard.',
    fp2_passwordLine: 'La tua password (anche nell\'e-mail):',
    fp2_openReport: 'Apri il rapporto',
    fp2_saveFailed: 'Non è stato ancora possibile salvare i risultati.',
    fp2_saveFailedSub: 'Controlla la connessione internet e riprova. Tieni aperta questa pagina.',
    fp2_tryAgain: 'Riprova',
    fp2_sessionTitle: 'C\'è qualcosa sul test che dovremmo sapere?',
    fp2_sessionOptional: 'Facoltativo · non cambia il risultato',
    fp2_cTired: 'Stanco o distratto',
    fp2_cCameraMic: 'Problema con fotocamera o microfono',
    fp2_cNoisy: 'Rumore o interruzioni',
    fp2_cLanguage: 'Non è la prima lingua',
    fp2_cHelped: 'Qualcuno ha aiutato a rispondere',
    fp2_cFroze: 'La pagina si è bloccata o è stata ricaricata',
    fp2_saveNotes: 'Salva note',
    fp2_notesSaved: 'Note salvate',
    fp2_notesFailed: 'Non è stato possibile salvare le note. Riprova.',
    fp_parentNote: '👨‍👩‍👧 Una nota per il genitore',
    fp_parentNoteDesc: "La valutazione è completata. Condividi eventuali osservazioni su come tuo figlio ha partecipato alle attività oggi (facoltativo).",
    fp_screeningResult: 'Risultato dello Screening',
    fp_riskTypical: 'Tipico — nessun indicatore significativo',
    fp_riskBorderline: 'Borderline — alcuni indicatori presenti',
    fp_riskHighRisk: 'Alto Rischio — diversi indicatori rilevati',
    fp_riskVeryHighRisk: 'Rischio Molto Alto — indicatori forti in vari domini',
    fp_confidence: 'Fiducia',
    fp_keyFindings: 'Risultati Principali',
    fp_disclaimer: 'Questo è solo uno strumento di screening — non una diagnosi clinica. Si prega di consultare uno psicologo educativo registrato per una valutazione completa.',
    fp_notAssessed: 'Non valutato',
    fp_percentile: 'º percentile',
    fp_domainTypical: '✓ Tipico',
    fp_domainBorderline: '⚠ Borderline',
    fp_domainHighRisk: '✗ Alto Rischio',
    fp_aiReportTitle: 'Rapporto Personalizzato AI',
    fp_aiGenerating: 'DysTest AI sta generando il tuo rapporto personalizzato…',
    fp_aiGenerated: 'Generato da DysTest AI · Non è una diagnosi clinica',
    fp_aiAnalysing: 'Analisi dei dati di valutazione…',
    fp_strengths: 'Punti di Forza',
    fp_areasToSupport: 'Aree da Supportare',
    fp_noDifficulties: 'Nessuna difficoltà significativa rilevata.',
    fp_eyeTracking: 'Tracciamento oculare:',
    fp_recommendations: 'Raccomandazioni',
    fp_nextStep: 'Passo successivo:',

    pp_title: 'Privacy Policy',
    pp_bannerTitle: 'La Tua Privacy è Sacra',
    pp_bannerDesc: "Crediamo che i tuoi dati personali siano tuoi, non nostri da vendere. Raccogliamo solo ciò che è necessario per fornirti uno screening accurato della dislessia, e lo proteggiamo con la sicurezza all'avanguardia del settore. Hai sempre il pieno controllo delle tue informazioni.",
    pp_contactTitle: 'Domande sulla Tua Privacy?',
    pp_contactDesc: "Siamo impegnati nella trasparenza. Se hai domande su come gestiamo i tuoi dati, siamo qui per aiutarti.",
    pp_privacyInquiries: 'Richieste sulla Privacy',
    pp_generalSupport: 'Supporto Generale',
    pp_acknowledgment: "Utilizzando il Servizio DysTest, riconosci di aver letto e compreso questa Privacy Policy.",

    tos_title: 'Termini di Servizio',
    tos_missionTitle: 'La Nostra Missione',
    tos_missionDesc: "Capire la propria mente non dovrebbe essere un lusso — è un diritto umano. La nostra missione è rendere lo screening della dislessia accessibile, conveniente e accurato per ogni famiglia che ne ha bisogno.",
    tos_contactTitle: 'Domande sui Termini?',
    tos_contactDesc: 'Siamo qui per aiutarti. Se hai domande sui nostri Termini di Servizio, non esitare a contattarci.',
    tos_acknowledgment: "Utilizzando il Servizio DysTest, riconosci di aver letto, compreso e accettato di essere vincolato dai presenti Termini di Servizio.",

    shared_quickNav: 'Navigazione Rapida',
    shared_backHome: '← Torna alla Home',
    shared_effectiveDate: 'Data di Entrata in Vigore: 30 ottobre 2025',
    shared_lastUpdated: 'Ultimo Aggiornamento: 30 ottobre 2025',
    shared_footerTagline: 'Rendere il test per la dislessia accurato, accessibile e conveniente.',
    shared_website: 'Sito Web',
    shared_email: 'Email',

    blog_knowledgeBadge: 'Centro Conoscenza DysTest',
    blog_title: 'Blog DysTest',
    blog_subtitle: "Approfondimenti esperti su dislessia, differenze di apprendimento e come l'AI sta rivoluzionando il rilevamento precoce e il supporto",
    blog_searchPlaceholder: 'Cerca articoli su dislessia, differenze di apprendimento, valutazione AI...',
    blog_catAll: 'Tutti',
    blog_catUnderstanding: 'Comprendere la Dislessia',
    blog_catEarlyDetection: 'Rilevamento Precoce',
    blog_catTechnology: 'Tecnologia',
    blog_catNews: 'Notizie',
    blog_featuredBadge: '⭐ In Evidenza',
    blog_featuredArticles: 'Articoli in Evidenza',
    blog_allArticles: 'Tutti gli Articoli',
    blog_article: 'articolo',
    blog_articles: 'articoli',
    blog_readMore: 'Leggi di più →',
    blog_found: 'Trovati',
    blog_forQuery: 'per',
    blog_noResults: 'Nessun articolo trovato',
    blog_noResultsDesc: 'Prova a modificare i criteri di ricerca o filtro',
    blog_clearFilters: 'Cancella filtri e mostra tutti gli articoli',
    blog_newsletterTitle: 'Rimani Aggiornato sulla Ricerca sulla Dislessia',
    blog_newsletterDesc: "Ricevi le ultime informazioni su ricerca sulla dislessia, tecnologia AI e strategie di apprendimento direttamente nella tua casella di posta.",
    blog_newsletterBtn: 'Iscriviti agli Aggiornamenti',
    blog_newsletterPrivacy: 'Niente spam. Annulla iscrizione in qualsiasi momento. Rispettiamo la tua privacy.',
    blog_newsletterEmailPlaceholder: 'Inserisci la tua email',
    blog_newsletterSending: 'Invio in corso…',
    blog_newsletterCheckInbox: 'Quasi fatto: controlla la tua casella di posta e clicca sul link per confermare.',
    blog_newsletterError: 'Qualcosa è andato storto. Riprova più tardi.',
    nws_working: 'Un momento…',
    nws_confirmedTitle: 'Sei iscritto',
    nws_confirmedBody: 'Grazie! Riceverai i nuovi articoli del blog, i documenti tecnici e la nostra newsletter. Ogni e-mail contiene un link per annullare l\'iscrizione.',
    nws_wasUnsubscribed: 'Questo indirizzo ha annullato l\'iscrizione. Iscriviti di nuovo dal blog per ricevere aggiornamenti.',
    nws_unsubTitle: 'Annullare l\'iscrizione agli aggiornamenti di DysTest?',
    nws_unsubBody: 'Non riceverai più nuovi articoli del blog, documenti tecnici o newsletter.',
    nws_unsubBtn: 'Annulla iscrizione',
    nws_unsubDoneTitle: 'Iscrizione annullata',
    nws_unsubDoneBody: 'Non riceverai più aggiornamenti. Hai cambiato idea? Puoi iscriverti di nuovo dal blog.',
    nws_invalidTitle: 'Questo link non è valido',
    nws_invalidBody: 'Il link potrebbe essere vecchio o incompleto. Puoi iscriverti di nuovo dal blog.',
    nws_toBlog: 'Vai al blog',
    blog_backToArticles: 'Torna agli Articoli',
    blog_loadingArticle: 'Caricamento articolo...',
    blog_articleNotFound: 'Articolo Non Trovato',
    blog_ctaTitle: 'Pronto a Saperne di Più?',
    blog_ctaDesc: "Scopri come DysTest può aiutare a identificare le differenze di apprendimento e sbloccare il potenziale di ogni bambino con la nostra valutazione basata su AI.",
    blog_tryDystest: 'Prova la Valutazione DysTest',
    blog_readMoreArticles: 'Leggi Altri Articoli',

    faq_badge: 'Hai Domande? Abbiamo le Risposte',
    faq_title: 'Domande Frequenti',
    faq_subtitle: 'Tutto quello che devi sapere sul nostro',
    faq_subtitleHighlight: 'Screening per la Dislessia con Tracciamento Oculare',
    faq_searchPlaceholder: "Cerca domande... (es. 'costo', 'privacy', 'quanto dura')",
    faq_mostPopular: 'Domande Più Popolari',
    faq_noResults: 'Nessuna domanda trovata corrispondente alla tua ricerca.',
    faq_clearFilters: 'Cancella Filtri',
    faq_stillHave: 'Hai ancora domande?',
    faq_supportDesc: 'Il nostro team di supporto è qui per aiutarti a trovare le risposte di cui hai bisogno. Di solito rispondiamo entro 24 ore.',
    faq_contactSupport: 'Contatta il Supporto',
    faq_startScreening: 'Inizia lo Screening',
    faq_catAll: 'Tutti',
    faq_related: 'Correlati:',

    about_badge: 'La Nostra Storia',
    about_title: 'Chi è DysTest',
    about_subtitle: 'Crediamo che ogni bambino meriti di essere capito — non solo testato.',
    about_backHome: '← Torna alla Home',
    about_ctaTitle: 'Pronto a Iniziare?',
    about_ctaDesc: "Inizia oggi uno screening compassionevole per tuo figlio e scopri come DysTest aiuta a sbloccare il potenziale di ogni studente.",
    about_startScreening: 'Inizia Screening',
    about_startAssessment: 'Inizia',
    about_navWhy: 'Perché Esiste DysTest',
    about_navMissionValues: 'Missione e Valori',
    about_navTechnology: 'Tecnologia',
    about_navTeam: 'Le Persone Dietro DysTest',

    ran_audio_preLetter: 'Denominazione lettere. Leggi ad alta voce ogni riga di lettere, il più velocemente possibile.',
    ran_audio_preDigit: 'Ora le cifre. Leggi ad alta voce ogni riga di numeri, il più velocemente possibile.',
    ran_audio_preColor: 'Ora i colori. Di\' il colore di ogni quadrato ad alta voce, il più velocemente possibile.',
    ran_audio_preObject: 'Ora gli oggetti. Nomina ogni immagine ad alta voce, il più velocemente possibile.',
    ran_audio_runLetter: 'Leggi ogni lettera ad alta voce il più velocemente possibile.',
    ran_audio_runDigit: 'Leggi ogni numero ad alta voce il più velocemente possibile.',
    ran_audio_runColor: 'Di\' il colore di ogni quadrato ad alta voce il più velocemente possibile.',
    ran_audio_runObject: 'Nomina ogni immagine ad alta voce il più velocemente possibile.',
    ran_audio_practice: 'Facciamo pratica. Di\' ogni lettera ad alta voce.',
    ran_intro_t1_heading: 'Diciamo alcune lettere! 🔤',
    ran_intro_t1_desc1: 'Vedrai grandi lettere sullo schermo.',
    ran_intro_t1_desc2: 'Di\' ognuna ad alta voce il più velocemente possibile!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Vedrai righe di lettere, cifre, colori e oggetti. Leggi ogni riga ad alta voce il più velocemente possibile — da sinistra a destra.',
    ran_intro_desc2: "Il valutatore premerà Riga successiva dopo che hai finito ogni riga. Faremo prima una breve pratica.",
    ran_intro_labLetters: 'Lettere',
    ran_intro_labDigits: 'Cifre',
    ran_intro_labColors: 'Colori',
    ran_intro_labObjects: 'Oggetti',
    ran_practice_t1_heading: 'Riesci a dirle? 👀',
    ran_practice_heading: 'Pratica',
    ran_practice_t1_desc: 'Di\' ogni lettera ad alta voce. Inizia da sinistra!',
    ran_practice_desc: "Leggi questa riga di lettere ad alta voce, da sinistra a destra. Il valutatore tocca Riga successiva quando hai finito.",
    ran_practice_hint: 'Di\': "a · o · s · p · k" — poi premi il pulsante qui sotto.',
    ran_btn_try: 'Proviamo! 🎉',
    ran_btn_practise: 'Facciamo pratica',
    ran_btn_skip: 'Salta',
    ran_btn_gotIt: 'Capito — inizia con le lettere →',
    ran_btn_begin: 'Inizia — leggi la riga 1 →',
    ran_btn_nextRow: 'Riga successiva',
    ran_btn_continue: 'Continua',
    ran_preLetter_title: 'Denominazione lettere (RAN-L)',
    ran_preLetter_subtitle: '50 lettere · 5 righe da 10. Leggi ogni riga ad alta voce il più velocemente possibile.',
    ran_preLetter_detail: 'Il valutatore toccherà Riga successiva dopo ogni riga.',
    ran_preLetter_btn: 'Mostra la griglia →',
    ran_preDigit_title: 'Lettere completate! Ora le cifre (RAN-D)',
    ran_preDigit_subtitle: 'Ora lo stesso compito con le cifre: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 cifre · 5 righe da 10 · stesse regole.',
    ran_preDigit_btn: 'Inizia le cifre →',
    ran_preColor_title: 'Cifre completate! Ora i colori (RAN-C)',
    ran_preColor_subtitle: 'Di\' il colore di ogni quadrato ad alta voce, il più velocemente possibile.',
    ran_preColor_detail: '50 quadrati colorati · 5 righe da 10 · stesse regole.',
    ran_preColor_btn: 'Inizia i colori →',
    ran_preObject_title: 'Colori completati! Ora gli oggetti (RAN-O)',
    ran_preObject_subtitle: 'Nomina ogni immagine ad alta voce, il più velocemente possibile.',
    ran_preObject_detail: '50 oggetti · 5 righe da 10 · stesse regole.',
    ran_preObject_btn: 'Inizia gli oggetti →',
    ran_done_t1_heading: 'Lavoro straordinario! 🌟',
    ran_done_heading: 'Tutti i compiti di denominazione completati!',
    ran_done_t1_desc: 'Hai detto tutte le lettere!',
    ran_done_desc: 'Ecco i risultati:',
    ran_badge: 'Test di Denominazione Rapida',
    ran_intro_watchDemo: '👀 Guarda come funziona',
    ran_intro_t1_lead: 'Guarda ogni lettera e dilla ad alta voce il più velocemente possibile — da sinistra a destra!',
    ran_intro_step1: 'Guarda la riga',
    ran_intro_step2: 'Di\' ognuna ad alta voce',
    ran_intro_step3: 'Vai il più veloce possibile!',
    ran_intro_demoLabel: 'Di\' ogni elemento ad alta voce, il più velocemente possibile!',
    ran_btn_start: 'Inizia 🚀',
    ran_btn_tapStart: 'Clicca per Iniziare la Riga 1',
    ran_btn_listening: 'Ascolto…',
    ran_btn_repeat: 'Ripeti istruzione',
    ran_processing: 'Elaborazione…',
    ran_transcribing: 'Trascrizione audio con Whisper…',
    ran_transcribingDesc: "Analisi accuratezza vocale — richiede alcuni secondi",
    ran_stat_totalTime: 'Tempo totale',
    ran_stat_itemsPerSec: 'Elementi/s',
    ran_stat_avgItem: 'Elemento medio',
    ran_stat_mistakes: 'Errori',
    ran_paceHint: 'Evidenziato = riga corrente · Il valutatore controlla il ritmo',
    ran_running_letter: '🔤 RAN-L — Lettere',
    ran_running_digit: '🔢 RAN-D — Numeri',
    ran_running_color: '🎨 RAN-C — Colori',
    ran_running_object: '🦎 RAN-O — Oggetti',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Home',
    nav_about: 'Chi siamo',
    nav_resources: 'Risorse',
    nav_startAssessment: 'Inizia la valutazione',
    nav_langMenuTitle: 'Lingua della valutazione',
    nav_langMenuHint: 'Storie e istruzioni seguono questa lingua',
    nav_techPapers: 'Articoli Tecnici',
    nav_blog: 'Blog',
    nav_guides: 'Guide',
    nav_faq: 'FAQ',

        wwt_badge: 'Test di scrittura di parole',
    wwt_introTitle: 'Ricorda e digita la parola',
    wwt_introDesc: 'Una parola appare per 5 secondi — poi si cancella lettera per lettera e tu la digiti a memoria',
    wwt_demoHint: 'La parola scompare — la digiti a memoria',
    wwt_startWriting: 'Inizia a scrivere!',
    wwt_rememberWord: 'Ricorda questa parola',
    wwt_watchCountdown: 'Guarda il conto alla rovescia — poi scrivila a memoria',
    wwt_typeWord: 'Scrivi la parola che hai visto',
    wwt_pressEnter: 'Scrivila e premi Invio o Avanti',
    wwt_nextWord: 'Parola successiva',
    wwt_finish: 'Fine',
    wwt_done: 'Bravo!',
    wwt_correct: 'parole corrette',
    wwt_continue: 'Continua',
    wwt_wordOf: 'Parola {current} di {total}',
    form_badgeText: 'Passo 1/8: Registrati',
    form_heading: 'Registrati e Inizia',
    form_privacyNote: 'I tuoi dati sono protetti dalle normative GDPR e MDR. Nessuna informazione personale identificabile viene condivisa con terze parti.',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Verifica microfono',
    mic_sub_checking: 'Verifica del microfono in corso…',
    mic_sub_ready: 'Microfono pronto — tocca Test per registrare',
    mic_sub_recording: 'Registrazione in corso… parla ora',
    mic_sub_retry: 'Non ti abbiamo sentito bene — riprova',
    mic_sub_passed: 'Il microfono funziona perfettamente!',
    mic_sub_denied: 'Accesso al microfono negato',
    mic_pleaseSpeak: '🗣️ Per favore, parla ora…',
    mic_retryBody: "Non siamo riusciti a sentirti chiaramente. Parla un po' più forte e riprova.",
    mic_testBtn: 'Testa microfono',
    mic_tryAgain: 'Riprova',
    mic_continueBtn: 'Continua',
    mic_skipDenied: 'Salta (nessun microfono)',
    mic_skip: 'Salta verifica microfono',
    ud_myDashboard: 'Il mio pannello',
    ud_myAssessmentReports: 'I miei rapporti di valutazione',
    ud_noAssessmentsFound: 'Nessuna valutazione completata trovata.',
    ud_assessmentsFoundSingular: '1 valutazione completata trovata.',
    ud_assessmentsFoundPlural: '{n} valutazioni completate trovate.',
    ud_loadError: 'Impossibile caricare le tue valutazioni. Controlla la connessione e aggiorna la pagina.',
    ud_serviceUnavailable: 'Il server è temporaneamente non disponibile (503). Si prega di attendere un momento e aggiornare la pagina.',
    ud_progressOverTime: 'Progressi nel tempo',
    ud_longitudinalSubtitle: '{n} valutazioni · tendenza del punteggio z composito',
    ud_typical: 'Tipico (z ≥ −0,5)',
    ud_borderline: 'Borderline (z < −0,5)',
    ud_highRisk: 'Alto rischio (z < −1,0)',
    ud_veryHighRisk: 'Rischio molto alto (z < −1,5)',
    ud_noAssessmentsFor: 'Nessuna valutazione trovata per',
    ud_completeAssessment: 'Completa una valutazione per vedere i tuoi risultati qui.',
    ud_startAssessment: 'Inizia una valutazione',
    ud_assessmentReport: 'Rapporto di valutazione',
    ud_completed: 'Completato',
    ud_accuracy: 'PRECISIONE',
    ud_blinks: 'OCCHIOLINI',
    ud_questions: 'DOMANDE',
    ud_rawData: 'Dati grezzi (JSON)',
    ud_tabEyeTracking: 'Tracciamento oculare',
    ud_tabRan: 'Analisi RAN',
    ud_tabStory: 'Analisi delle storie',
    ud_gazePlaybackTitle: 'Riproduzione tracciamento oculare — 3 modalità: Griglia · Heatmap · Percorso',
    ud_noGazeData: 'Nessun dato di tracciamento oculare disponibile per questa valutazione.',
    ud_gazeDataNote: 'I dati di tracciamento oculare vengono acquisiti durante la sessione di valutazione dal vivo e archiviati con il rapporto.',
    ud_ranTitle: 'RAN — Risultati della denominazione automatizzata rapida',
    ud_totalTime: 'Tempo totale',
    ud_rawSpeed: 'Velocità grezza',
    ud_correctedSpeed: 'Velocità corretta',
    ud_errors: 'Errori',
    ud_rowTimings: 'Tempi per riga',
    ud_transcriptComparison: 'Confronto trascrizione',
    ud_row: 'Riga',
    ud_audioNote: 'La riproduzione audio è disponibile nel rapporto ZIP completo · Scarica il rapporto completo (ZIP) sopra',
    ud_storyTitle: 'Analisi della lettura della storia',
    ud_story1Label: 'Storia 1 — Fase di lettura',
    ud_story2Label: 'Storia 2 — Fase di lettura',
    ud_readingTime: 'Tempo di lettura',
    ud_fixations: 'Fissazioni',
    ud_regressions: 'Regressioni',
    ud_avgFixation: 'Fiss. media',
    ud_saccades: 'Saccadi',
    ud_blinkRate: 'Frequenza occhiolini',
    ud_gazeStoryTitle: 'Tracciamento oculare — Pagine delle storie',
    ud_noStoryGaze: 'Dati di tracciamento oculare delle storie non disponibili per questa valutazione.',
    ud_footer: 'I tuoi dati sono archiviati in modo sicuro solo su questo dispositivo.',
    ud_changePassword: 'Cambia password',
    ud_changePasswordDesc: 'Imposta una nuova password per il tuo account. La userai la prossima volta che accedi.',
    ud_passwordUpdated: 'Password aggiornata con successo',
    ud_newPasswordPlaceholder: 'Nuova password (min. 4 caratteri)',
    ud_saving: 'Salvataggio…',
    ud_saveNewPassword: 'Salva nuova password',
    ud_passwordTooShort: 'La password deve contenere almeno 4 caratteri.',
    ud_passwordUpdateFailed: 'Impossibile aggiornare la password. Per favore riprova.',
    ud_accuracySuffix: 'precisione',
    acp_tabCamera: 'Fotocamera',
    acp_tabKeyboard: 'Tastiera',
    acp_tabMicrophone: 'Microfono',
    acp_checkingCameraQuality: 'Verifica della qualità della fotocamera — ci vogliono alcuni secondi',
    acp_allChecksPassed: 'Tutti i controlli superati!',
    acp_allSystemsReady: 'Fotocamera, tastiera e microfono sono pronti.',
    mini_step: 'Passo',
    scp_setupComplete: '🎉 Configurazione completata!',
    scp_allSetSubtitle: 'Sei pronto per la valutazione della dislessia',
    scp_setupQualityScore: 'Punteggio qualità configurazione',
    scp_excellentSetup: 'Eccellente qualità di configurazione per una valutazione accurata',
    scp_completedSteps: '✅ Passaggi completati',
    scp_cameraReadiness: 'Preparazione della fotocamera',
    scp_cameraStabilityPassed: 'Controllo stabilità di 10 secondi superato',
    scp_keyboardCapture: 'Acquisizione tastiera',
    scp_keystrokeData: 'Dati clinici di battitura acquisiti',
    scp_eyeCalibration: 'Calibrazione oculare',
    scp_calibrationCompleted: 'Calibrazione completata ({pct}% di precisione)',
    scp_whatsNext: 'Cosa c\'è dopo?',
    scp_whatsNextBody: 'Inizierai la valutazione della lettura dove analizzeremo i movimenti oculari, le espressioni facciali e i modelli di lettura per fornire uno screening completo della dislessia.',
    scp_startAssessment: 'Avvia valutazione dislessia',
    scp_startingAssessment: 'Avvio valutazione...',
    scp_estimatedTime: 'Tempo stimato: 10-15 minuti',

    // Griglia report UserDashboard
    ud_view: 'Visualizza',
    ud_report_userInfo: 'Informazioni utente',
    ud_report_envSetup: 'Configurazione ambiente',
    ud_report_wordIcon: 'Abbinamento parola-icona',
    ud_report_ran: 'Analisi RAN',
    ud_report_story: 'Analisi storia',
    ud_report_wordWriting: 'Scrittura parole',
    ud_report_feedback: 'Feedback',
    ud_report_summary: 'Riepilogo',
    ul_platform: 'Piattaforma di valutazione della dislessia',
    ul_invalidCredentials: 'Email o password non valide. Controlla le credenziali mostrate alla fine della valutazione.',
    ul_loginFailed: 'Accesso non riuscito. Riprova.',
    ul_resetFailed: 'Qualcosa è andato storto. Riprova.',
    ul_backToSignIn: 'Torna all’accesso',
    ul_checkEmail: 'Controlla la tua email',
    ul_smtpDevNotice: 'SMTP non configurato (dev). Password temporanea:',
    ul_resetSent: 'Se {email} è registrato, una nuova password è in arrivo.',
    ul_signIn: 'Accedi',
    ul_resetPassword: 'Reimposta password',
    ul_resetPasswordDesc: 'Inserisci la tua email e ti invieremo una nuova password.',
    ul_emailAddress: 'Indirizzo email',
    ul_emailPlaceholder: 'tu@email.com',
    ul_sending: 'Invio…',
    ul_sendNewPassword: 'Invia nuova password',
    ul_welcomeBack: 'Bentornato',
    ul_signInSubtitle: 'Accedi per vedere i risultati della valutazione',
    ul_password: 'Password',
    ul_passwordPlaceholder: 'La tua password',
    ul_hidePassword: 'Nascondi password',
    ul_showPassword: 'Mostra password',
    ul_forgotPassword: 'Password dimenticata?',
    ul_signingIn: 'Accesso in corso…',
    ul_signInDashboard: 'Accedi alla dashboard',
    ul_firstTime: 'Prima volta qui? Il tuo account è stato creato automaticamente dopo la valutazione. Controlla la tua email per i dati di accesso.',
    ul_footer: 'Conforme GDPR e MDR · Nessun video archiviato',

    mg_title: 'Un attimo di pazienza, per la scienza!',
    mg_body: 'DysTest analizza i movimenti dei tuoi occhi (al pixel!), la tua velocità di battitura e la tua voce al millisecondo.\n\nUna tecnologia super intelligente, ma ha un punto debole: non funziona mentre lo schermo ti traballa in mano. Quindi apri un portatile o un computer per un risultato affidabile!',
    mg_howTo: 'Come iniziare',
    mg_step1: 'Apri dystest.com su un portatile o un computer fisso',
    mg_step2: 'Assicurati che webcam e tastiera siano collegate',
    mg_step3: 'Usa Chrome o Firefox per risultati migliori',
    mg_returnHome: 'Torna alla home page',
    mg_shareLink: 'Inviami il link',
    mg_copyLink: 'Copia link',
    mg_linkCopied: 'Link copiato',
    mg_alreadyDone: 'Hai già fatto un test?',
    mg_loginLink: 'Accedi per vedere il rapporto',
    mg_emailLabel: 'Il tuo indirizzo e-mail',
    mg_emailPlaceholder: 'nome@esempio.it',
    mg_emailSend: 'Invia',
    mg_emailSent: 'Inviato! Apri l\'e-mail sul portatile o computer per iniziare il test.',
    mg_emailError: 'Impossibile inviare l\'e-mail. Controlla l\'indirizzo e riprova.',
};

export default it;
